/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsNaN } from '../../factoriesAny.js';
export var isNaNDependencies = {
  typedDependencies: typedDependencies,
  createIsNaN: createIsNaN
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsNaN.generated.js
// module id = 180
// module chunks = 0